<script lang="ts">
  import Logo from '$components/Logos/Logo.svelte';
  import BlockReskinLogo from '$components/Logos/reskin_logos/BlockReskinLogo.svelte';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { cx } from '@emotion/css';
  import { ResponsiveVars } from '@twist/core';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';

  let brandReskinEnabled = $derived(flagValue(FEATURE_FLAGS.BRAND_RESKIN));

  const responsiveVars = new ResponsiveVars()
    .addFluid('logo-size', toFluidVarInput(30, 30))
    .addFluid('logo-padding', toFluidVarInput(5, 5))
    .toCSS();

  const reskinResponsiveVars = new ResponsiveVars()
    .addFluid('logo-height', toFluidVarInput(16, 21))
    .addFluid('logo-width', toFluidVarInput(16, 21))
    .toCSS();
</script>

{#if brandReskinEnabled}
  <div class={`${reskinResponsiveVars} reskin-nav-logo`}>
    <a class="logo reskin" href="/" aria-label="visit home page" data-testid="logo-reskin">
      <BlockReskinLogo />
    </a>
  </div>
{:else}
  <div class={cx('logo', responsiveVars)}>
    <div class="logo__inner">
      <Logo />
    </div>
  </div>
{/if}

<style lang="scss">
  .logo {
    padding: var(--logo-padding);

    &:hover,
    &:focus-within {
      background: none;
      & :global(*) {
        outline: none;
      }
    }

    &:active {
      opacity: 0.6;
    }

    .logo__inner {
      width: var(--logo-size);
      height: var(--logo-size);
    }

    &.reskin {
      background-color: transparent;
      color: black;
      transition: fill 0.2s ease;
      cursor: pointer;

      &:hover {
        color: #666666;
      }
    }
  }

  .reskin-nav-logo {
    width: var(--logo-width);
    height: var(--logo-height);
  }
</style>
